<!-- Card fantasma, usado tanto na coluna inteira em carregamento quanto na paginação de uma
     coluna já carregada. Template único para as duas situações não saírem de sincronia. -->
<ng-template #cardEsqueleto>
    <div class="pv-card pv-card--skeleton" aria-hidden="true">
        <div class="pv-skeleton-linha">
            <app-loading-box height="10" width="42"></app-loading-box>
            <!-- Avatar E botão de ações: sem o segundo, o avatar cai grudado na borda e o
                 fantasma deixa de ter a geometria do card real. -->
            <span class="pv-skeleton-acoes">
                <app-loading-box height="22" width="22"></app-loading-box>
                <app-loading-box height="18" width="18"></app-loading-box>
            </span>
        </div>
        <app-loading-box height="12" margin="8px 0 6px 0"></app-loading-box>
        <app-loading-box height="10" width="72" margin="0 0 12px 0"></app-loading-box>
        <div class="pv-skeleton-linha pv-skeleton-rodape">
            <app-loading-box height="11" width="78"></app-loading-box>
            <app-loading-box height="9" width="62"></app-loading-box>
        </div>
    </div>
</ng-template>

@if (isSkeleton) {
<!-- Coluna fantasma: MESMA caixa da coluna real, só o conteúdo vira loading-box. Reusar a
         caixa é o que impede a tela de "pular" quando os dados chegam. -->
<div class="pv-coluna pv-coluna--skeleton" aria-hidden="true">
    <!-- A faixa do topo fica neutra: a cor pertence à etapa, que ainda não chegou. -->
    <div class="pv-col-accent pv-col-accent--skeleton"></div>

    <div class="pv-col-header">
        <app-loading-box height="26" width="26"></app-loading-box>
        <div class="pv-col-header-info">
            <app-loading-box height="11" width="96" margin="0 0 5px 0"></app-loading-box>
            <app-loading-box height="9" width="62"></app-loading-box>
        </div>
        <app-loading-box height="20" width="22"></app-loading-box>
        <!-- Botão de recolher: mesmo motivo do card, senão o badge encosta na borda. -->
        <app-loading-box height="18" width="18"></app-loading-box>
    </div>

    <div class="pv-cards-area">
        @for (slot of slotsEsqueleto; track slot) {
        <ng-container [ngTemplateOutlet]="cardEsqueleto"></ng-container>
        }
    </div>
</div>
} @else if (coluna.isRecolhida) {
<!-- Coluna recolhida: tira estreita com o nome girado, mesmo tratamento do processo-compras. -->
<button type="button" class="pv-col-recolhida" [style.border-top-color]="coluna.cor.principal"
    (click)="recolher.emit(coluna)" [matTooltip]="'Expandir ' + coluna.nome">
    <span class="pv-col-icon" [style.border-color]="coluna.cor.principal" [style.background]="coluna.cor.fundo"
        [style.color]="coluna.cor.principal">
        <mat-icon class="material-symbols-outlined">{{ coluna.nomeIcone }}</mat-icon>
    </span>
    <span class="pv-col-badge">{{ coluna.totalRegistros }}</span>
    <span class="pv-col-nome-vertical">{{ coluna.nome }}</span>
    <mat-icon class="material-symbols-outlined pv-col-expandir">keyboard_double_arrow_right</mat-icon>
</button>
} @else {
<div class="pv-coluna" [class.pv-coluna--destino-valido]="isDestinoValido"
    [class.pv-coluna--destino-bloqueado]="isDestinoBloqueado" (pointerenter)="ponteiroEntrou.emit(coluna)">
    <div class="pv-col-accent" [style.background]="coluna.cor.principal"></div>

    <div class="pv-col-header">
        <span class="pv-col-icon" [style.border-color]="coluna.cor.principal" [style.background]="coluna.cor.fundo"
            [style.color]="coluna.cor.principal">
            <mat-icon class="material-symbols-outlined">{{ coluna.nomeIcone }}</mat-icon>
        </span>

        <div class="pv-col-header-info">
            <div class="pv-col-nome" [matTooltip]="coluna.nome">{{ coluna.nome }}</div>
            @if (isMostrarSoma) {
            <div class="pv-col-soma">{{ coluna.somaValorTotal | abnt: 'preco' : 2 }}</div>
            }
        </div>

        @if (exibeCadeado) {
        <mat-icon class="material-symbols-outlined pv-col-lock" [matTooltip]="tooltipCadeado">lock</mat-icon>
        }

        <span class="pv-col-badge">{{ coluna.totalRegistros }}</span>

        <button type="button" class="pv-icon-btn" (click)="recolher.emit(coluna)" matTooltip="Recolher">
            <mat-icon class="material-symbols-outlined">keyboard_double_arrow_left</mat-icon>
        </button>
    </div>

    <!-- O cdkDropList vive AQUI, não na .pv-coluna: a lista de itens arrastáveis é a área de
             cards. Estando na coluna, um fantasma sem card para se ancorar (coluna vazia) era
             anexado como último filho do drop list — depois desta área, no rodapé da coluna, sem
             o padding nem o gap dos cards. -->
    <div class="pv-cards-area" cdkDropList [cdkDropListData]="coluna.cards" [id]="'pv-drop-' + coluna.idEtapaKanban"
        [cdkDropListEnterPredicate]="enterPredicate" [cdkDropListAutoScrollStep]="36"
        [cdkDropListHasAnchor]="true" (cdkDropListDropped)="onDrop($event)">
        @for (card of coluna.cards; track card.idVenda) {
        <div class="pv-card" [class.pv-card--somente-leitura]="isSomenteLeitura" cdkDrag [cdkDragData]="card"
            [cdkDragDisabled]="!podeArrastar" [cdkDragStartDelay]="atrasoDeArraste"
            (cdkDragStarted)="arrasteIniciou.emit(card)"
            (cdkDragEnded)="arrasteTerminou.emit()"
            (click)="abrirCard.emit(card)">
            <app-pv-card [card]="card" [isFaixaExterna]="isSomenteLeitura"
                (editar)="abrirCard.emit($event)"
                [podeCriarModelo]="podeCriarModelo(card)"
                (criarModelo)="criarModelo.emit($event)"
                [podeClonar]="podeInserir"
                (clonar)="clonar.emit($event)"
                [podeExcluir]="podeExcluir"
                [podeLancarFinanceiro]="podeLancarFinanceiro"
                [podeExcluirFinanceiro]="podeExcluirFinanceiro"
                [podeLancarEstoque]="podeLancarEstoque"
                [podeExcluirEstoque]="podeExcluirEstoque"
                (verHistorico)="verHistorico.emit($event)"
                (verOportunidadesCliente)="verOportunidadesCliente.emit($event)"
                (excluir)="excluir.emit($event)"
                [permissoesOportunidade]="permissoesOportunidade"
                (verOportunidade)="verOportunidade.emit($event)"
                (criarOportunidade)="criarOportunidade.emit($event)"
                (vincularOportunidade)="vincularOportunidade.emit($event)"
                (desvincularOportunidade)="desvincularOportunidade.emit($event)"
                (lancarFinanceiro)="lancarFinanceiro.emit($event)"
                (excluirFinanceiro)="excluirFinanceiro.emit($event)"
                (lancarEstoque)="lancarEstoque.emit($event)"
                (excluirEstoque)="excluirEstoque.emit($event)"
                (verFinanceiro)="verFinanceiro.emit($event)"></app-pv-card>
        </div>
        } @empty {
        <div class="pv-col-vazia">{{ textoVazio }}</div>
        }

        <!-- Paginação da coluna: os cards já carregados ficam, e os novos entram como
                 fantasmas embaixo — não se troca a coluna inteira por um spinner. -->
        @if (coluna.isCarregandoMais) {
        @for (slot of slotsEsqueleto; track slot) {
        <ng-container [ngTemplateOutlet]="cardEsqueleto"></ng-container>
        }
        } @else if (coluna.temMais) {
        <button type="button" class="pv-ver-mais" (click)="verMais.emit(coluna)">
            <mat-icon class="material-symbols-outlined">expand_more</mat-icon>
            Ver mais
        </button>
        }
    </div>
</div>
}